import { generateSimpleAction } from 'utils/actionHelpers/actionHelpers'

export const HO_AUTH_LOGIN = 'HO_AUTH_LOGIN'
export const HO_AUTH_LOGIN_SOCIAL_NETWORK = 'HO_AUTH_LOGIN_SOCIAL_NETWORK'

export const hoAuthLogin = generateSimpleAction(HO_AUTH_LOGIN)
export const hoAuthLoginSocialNetwork = generateSimpleAction(
  HO_AUTH_LOGIN_SOCIAL_NETWORK,
)
